import { computed, ComputedRef, CSSProperties, SetupFunction } from 'vue';
import { fontSizes, ProfilePhoto, ProfilePhotoSize, profilePhotoSizes } from './ProfilePhoto.types';

type Props = {
	profilePhoto: ProfilePhoto;
	size: ProfilePhotoSize;
};

type View = {
	chipStyle: ComputedRef<CSSProperties>;
};

const profilePhotoController: SetupFunction<Props, View> = (props) => {
	const chipStyle = computed(() => {
		const { width, height } = profilePhotoSizes[props.size] || profilePhotoSizes.large;

		return {
			width: `${width}px`,
			height: `${height}px`,
			fontSize: `${fontSizes(props.size)}px`,
		};
	});

	return {
		chipStyle,
	};
};

export { type Props, type View, profilePhotoController };
